import * as actionTypes from "./actionTypes";

export const setDynamicRouteConfiguration = (dynamicRouteConfig) => (dispatch) => {
  dispatch({
    payload: { ...dynamicRouteConfig },
    type: actionTypes.SET_DYNAMIC_ROUTE_CONFIGURATION,
  });
};

export const setOmnisearchDisplayStatus = (omnisearchDisplayStatus) => (dispatch) => {
  dispatch({
    payload: omnisearchDisplayStatus,
    type: actionTypes.SET_OMNISEARCH_DISPLAY_STATUS,
  });
};
